import React from 'react'
import { Alert } from 'react-bootstrap'
import Swal from 'sweetalert2'
import axios from 'axios';
import Resizer from "react-image-file-resizer";
import { smsconfig ,smsBalance } from './BaseURL';


function Message({variant , children}) {
  return (
    <Alert variant= {variant}>
      {children}
    </Alert>
  )
}

export default Message


export const successMessage=(title ,message) => {
  Swal.fire({
    position: "center",
    icon: "success",
    title: title ,
    text: message,
    showConfirmButton: false,
    timer: 10000
  });
}

export const ErrorMessage=(title ,message) => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: title ,
    text: message,
    showConfirmButton: false,
    timer: 1500000
  });
}


export const loadingErrorMessage=(err) => {
  Swal.fire({
    title: 'Error!',
    text: err,
    icon: 'error'
  });
}


export const parient_state=(age , parient_state) => {
  if(age <12){
    parient_state = "Child";
  }else {
    parient_state = "Adult";
  }
}

const loadSmsConfig = async () => {
  try {
    const response = await axios.get(smsconfig);
    if (response.data.success) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error('Failed to load SMS config:', error);
    return null;
  }
};


// ─── Check SMS Balance ────────────────────────────────────────────────────────
/**
 * Fetches the current SMS credit balance from Arkesel.
 * Uses the api_key from loadSmsConfig — same source as sms_Welcome.
 * Returns { success: true, data: { balance, user, currency, status, ... } }
 * or      { success: false, error: 'message' }
 */
export const checkSmsBalance = async () => {
  try {
    const res = await axios.get(smsBalance);
    return res.data;
  } catch (error) {
    console.error('SMS balance check failed:', error);
    return { success: false };
  }
};


// NEW: sms_Welcome — fires on last step after patient is saved
export const sms_Welcome = async (tel, patientName, patientId, insuranceType) => {
  const config = await loadSmsConfig();
  if (!config) return;

  const data = {
    sender: config.sender_id,
    message: `Hi ${patientName}, welcome to ${config.facility_name}! Your Patient ID is ${patientId}. Thank you for choosing us for your healthcare needs`,
    recipients: [tel]
  };

  axios({
    method: 'post',
    url: config.api_url,
    headers: { 'api-key': config.api_key },
    data 
  })
    .then(res => console.log('Welcome SMS sent:', JSON.stringify(res.data)))
    .catch(err => console.error('Welcome SMS error:', err));
};


export const sms_Deposit =(tel ,cname,acno,drcr,amount,desc,dat,bal)=> {
  
  const data = {"sender": "Startccu",
               "message": "Hi "+ cname + " Your A/C N0:XXXX" +acno +" has been "+drcr+" GHS "+amount+"\n"+"Desc:"+desc+" \n"+"Date:"+dat+"\n"+"Bal:GHS "+bal,
               "recipients": [tel]};
   
  const config = {
    method: 'post',
    url: 'https://sms.arkesel.com/api/v2/sms/send',
    headers: {
     'api-key': 'WktJUlNWUGxhVU5oUHBCRU1aa3Q'
    },
    data : data
  };
 
  axios(config)
  .then(function (response) {
    console.log(JSON.stringify(response.data));
  })
  .catch(function (error) {
    console.log(error);
  });
}


export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      200,
      200,
      "PNG",
      70,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });


export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS'
  }).format(amount);
};


export const formatWithOutSom = (amount) => {
  return new Intl.NumberFormat('en-GH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};


export const formatDateSafe = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
  return date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};


export const MEDICATION_ROUTES = [
  "Oral",
  "IV",
  "IM",
  "SC",
  "ID",
  "Topical",
  "Inhalation",
  "Nebulization",
  "Sublingual",
  "Buccal",
  "Rectal",
  "Vaginal",
  "Intranasal",
  "Ophthalmic",
  "Otic",
  "Transdermal",
  "Epidural",
  "Intrathecal"
];


export const frequencyMap = {
  "b.i.d": "Twice daily", "bid": "Twice daily", "twice daily": "Twice daily",
  "t.i.d": "Three times daily", "tid": "Three times daily", "three times daily": "Three times daily",
  "q.i.d": "Four times daily", "qid": "Four times daily", "four times daily": "Four times daily",
  "daily": "Once daily", "od": "Once daily", "qd": "Once daily", "once daily": "Once daily",
  "nocte": "At night", "at night": "At night", "nighttime": "At night",
  "stat": "Immediately", "immediately": "Immediately", "now": "Immediately",
  "@ 0, 12 & 24hrs": "At 0, 12 and 24 hours", "at 0, 12 & 24hrs": "At 0, 12 and 24 hours",
  "qhs": "At bedtime", "at bedtime": "At bedtime", "bedtime": "At bedtime",
  "q4h": "Every 4 hours", "every 4 hours": "Every 4 hours", "q 4h": "Every 4 hours",
  "q6h": "Every 6 hours", "every 6 hours": "Every 6 hours", "q 6h": "Every 6 hours",
  "q8h": "Every 8 hours", "every 8 hours": "Every 8 hours", "q 8h": "Every 8 hours",
  "q12h": "Every 12 hours", "every 12 hours": "Every 12 hours", "q 12h": "Every 12 hours",
  "stat, then b.i.d * 24hrs": "Stat dose, then twice daily for 24 hours",
  "stat then bid x 24h": "Stat dose, then twice daily for 24 hours",
  "q4-6h": "Every 4 to 6 hours", "every 4-6 hours": "Every 4 to 6 hours", "q 4-6h": "Every 4 to 6 hours",
  "qwk,prn": "Weekly, as needed", "weekly prn": "Weekly, as needed", "weekly as needed": "Weekly, as needed",
  "prn": "As needed", "as needed": "As needed", "pro re nata": "As needed",
  "ac": "Before meals", "ante cibum": "Before meals", "before meals": "Before meals",
  "pc": "After meals", "post cibum": "After meals", "after meals": "After meals",
  "mane": "In the morning", "morning": "In the morning", "in the morning": "In the morning",
  "om": "Every morning", "every morning": "Every morning",
  "on": "Every night", "every night": "Every night",
  "q2h": "Every 2 hours", "every 2 hours": "Every 2 hours", "q 2h": "Every 2 hours",
  "q3h": "Every 3 hours", "every 3 hours": "Every 3 hours", "q 3h": "Every 3 hours",
  "sos": "If necessary", "if necessary": "If necessary",
  "alternate days": "Every other day", "alt days": "Every other day", "every other day": "Every other day",
  "weekly": "Once weekly", "once weekly": "Once weekly", "1x weekly": "Once weekly",
  "monthly": "Once monthly", "once monthly": "Once monthly", "1x monthly": "Once monthly",
};


export const frequencyMultiplier = {
  "Once daily": 1,
  "Twice daily": 2,
  "Three times daily": 3,
  "Four times daily": 4,
  "At night": 1,
  "Immediately": 1,
  "At 0, 12 and 24 hours": 3,
  "At bedtime": 1,
  "Every 2 hours": 12,
  "Every 3 hours": 8,
  "Every 4 hours": 6,
  "Every 6 hours": 4,
  "Every 8 hours": 3,
  "Every 12 hours": 2,
  "Every 4 to 6 hours": 4,
  "Weekly, as needed": 0,
  "As needed": 0,
  "Before meals": 3,
  "After meals": 3,
  "In the morning": 1,
  "Every morning": 1,
  "Every night": 1,
  "If necessary": 0,
  "Every other day": 0.5,
  "Once weekly": 1 / 7,
  "Once monthly": 1 / 30,
  "Stat dose, then twice daily for 24 hours": 3
};


export const standardFrequencies = [
  "Once daily", "Twice daily", "Three times daily", "Four times daily",
  "At night", "Immediately", "At 0, 12 and 24 hours", "At bedtime",
  "Every 2 hours", "Every 3 hours", "Every 4 hours", "Every 6 hours",
  "Every 8 hours", "Every 12 hours", "Every 4 to 6 hours", "Weekly, as needed",
  "As needed", "Before meals", "After meals", "In the morning", "Every morning",
  "Every night", "If necessary", "Every other day", "Once weekly", "Once monthly",
  "Stat dose, then twice daily for 24 hours"
];


export const frequencyTimeMap = {
  'stat': ['02:00:00 AM'],
  'immediately': ['02:00:00 AM'],
  'now': ['02:00:00 AM'],
  'o.d': ['08:00:00 AM'],
  'od': ['08:00:00 AM'],
  'daily': ['08:00:00 AM'],
  'once daily': ['08:00:00 AM'],
  'qd': ['08:00:00 AM'],
  'o.m': ['08:00:00 AM'],
  'om': ['08:00:00 AM'],
  'mane': ['08:00:00 AM'],
  'morning': ['08:00:00 AM'],
  'in the morning': ['08:00:00 AM'],
  'every morning': ['08:00:00 AM'],
  'b.i.d': ['08:00:00 AM', '08:00:00 PM'],
  'bid': ['08:00:00 AM', '08:00:00 PM'],
  'bd': ['08:00:00 AM', '08:00:00 PM'],
  'twice daily': ['08:00:00 AM', '08:00:00 PM'],
  't.i.d': ['08:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'tid': ['08:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'tds': ['08:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'three times daily': ['08:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'q.i.d': ['06:00:00 AM', '12:00:00 PM', '06:00:00 PM', '12:00:00 AM'],
  'qid': ['06:00:00 AM', '12:00:00 PM', '06:00:00 PM', '12:00:00 AM'],
  'qds': ['06:00:00 AM', '12:00:00 PM', '06:00:00 PM', '12:00:00 AM'],
  'four times daily': ['06:00:00 AM', '12:00:00 PM', '06:00:00 PM', '12:00:00 AM'],
  'nocte': ['10:00:00 PM'],
  'at night': ['10:00:00 PM'],
  'nighttime': ['10:00:00 PM'],
  'qhs': ['10:00:00 PM'],
  'at bedtime': ['10:00:00 PM'],
  'bedtime': ['10:00:00 PM'],
  'on': ['10:00:00 PM'],
  'every night': ['10:00:00 PM'],
  'q2h': ['12:00:00 AM', '02:00:00 AM', '04:00:00 AM', '06:00:00 AM', '08:00:00 AM', '10:00:00 AM', '12:00:00 PM', '02:00:00 PM', '04:00:00 PM', '06:00:00 PM', '08:00:00 PM', '10:00:00 PM'],
  'every 2 hours': ['12:00:00 AM', '02:00:00 AM', '04:00:00 AM', '06:00:00 AM', '08:00:00 AM', '10:00:00 AM', '12:00:00 PM', '02:00:00 PM', '04:00:00 PM', '06:00:00 PM', '08:00:00 PM', '10:00:00 PM'],
  'q 2h': ['12:00:00 AM', '02:00:00 AM', '04:00:00 AM', '06:00:00 AM', '08:00:00 AM', '10:00:00 AM', '12:00:00 PM', '02:00:00 PM', '04:00:00 PM', '06:00:00 PM', '08:00:00 PM', '10:00:00 PM'],
  'q3h': ['12:00:00 AM', '03:00:00 AM', '06:00:00 AM', '09:00:00 AM', '12:00:00 PM', '03:00:00 PM', '06:00:00 PM', '09:00:00 PM'],
  'every 3 hours': ['12:00:00 AM', '03:00:00 AM', '06:00:00 AM', '09:00:00 AM', '12:00:00 PM', '03:00:00 PM', '06:00:00 PM', '09:00:00 PM'],
  'q 3h': ['12:00:00 AM', '03:00:00 AM', '06:00:00 AM', '09:00:00 AM', '12:00:00 PM', '03:00:00 PM', '06:00:00 PM', '09:00:00 PM'],
  'q4h': ['12:00:00 AM', '04:00:00 AM', '08:00:00 AM', '12:00:00 PM', '04:00:00 PM', '08:00:00 PM'],
  'every 4 hours': ['12:00:00 AM', '04:00:00 AM', '08:00:00 AM', '12:00:00 PM', '04:00:00 PM', '08:00:00 PM'],
  'q 4h': ['12:00:00 AM', '04:00:00 AM', '08:00:00 AM', '12:00:00 PM', '04:00:00 PM', '08:00:00 PM'],
  'q6h': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  'every 6 hours': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  'q 6h': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  'q8h': ['06:00:00 AM', '02:00:00 PM', '10:00:00 PM'],
  'every 8 hours': ['06:00:00 AM', '02:00:00 PM', '10:00:00 PM'],
  'q 8h': ['06:00:00 AM', '02:00:00 PM', '10:00:00 PM'],
  'q12h': ['08:00:00 AM', '08:00:00 PM'],
  'every 12 hours': ['08:00:00 AM', '08:00:00 PM'],
  'q 12h': ['08:00:00 AM', '08:00:00 PM'],
  'q4-6h': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  'every 4-6 hours': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  'q 4-6h': ['12:00:00 AM', '06:00:00 AM', '12:00:00 PM', '06:00:00 PM'],
  '@ 0, 12 & 24hrs': ['12:00:00 AM', '12:00:00 PM', '12:00:00 AM'],
  'at 0, 12 & 24hrs': ['12:00:00 AM', '12:00:00 PM', '12:00:00 AM'],
  'ac': ['07:30:00 AM', '12:30:00 PM', '06:30:00 PM'],
  'before meals': ['07:30:00 AM', '12:30:00 PM', '06:30:00 PM'],
  'ante cibum': ['07:30:00 AM', '12:30:00 PM', '06:30:00 PM'],
  'pc': ['09:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'after meals': ['09:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'post cibum': ['09:00:00 AM', '02:00:00 PM', '08:00:00 PM'],
  'prn': ['08:00:00 AM'],
  'as needed': ['08:00:00 AM'],
  'pro re nata': ['08:00:00 AM'],
  'sos': ['08:00:00 AM'],
  'if necessary': ['08:00:00 AM'],
  'stat, then b.i.d * 24hrs': ['02:00:00 AM', '08:00:00 AM', '08:00:00 PM'],
  'stat then bid x 24h': ['02:00:00 AM', '08:00:00 AM', '08:00:00 PM'],
  'qwk,prn': ['08:00:00 AM'],
  'weekly prn': ['08:00:00 AM'],
  'weekly as needed': ['08:00:00 AM'],
  'alternate days': ['08:00:00 AM'],
  'alt days': ['08:00:00 AM'],
  'every other day': ['08:00:00 AM'],
  'weekly': ['08:00:00 AM'],
  'once weekly': ['08:00:00 AM'],
  '1x weekly': ['08:00:00 AM'],
  'monthly': ['08:00:00 AM'],
  'once monthly': ['08:00:00 AM'],
  '1x monthly': ['08:00:00 AM'],
};


export const getFrequencyTimes = (frequency) => {
  if (!frequency) return ['08:00:00 AM'];
  
  const freq = frequency.toLowerCase().trim();
  
  if (frequencyTimeMap[freq]) {
    return frequencyTimeMap[freq];
  }
  
  const partialMatch = Object.keys(frequencyTimeMap).find(key => 
    freq.includes(key) || key.includes(freq)
  );
  
  if (partialMatch) {
    return frequencyTimeMap[partialMatch];
  }
  
  console.warn(`Unknown frequency: ${frequency}, using default (once daily)`);
  return ['08:00:00 AM'];
};